export default "__VITE_ASSET__P4jykSJX__"